import { getConfig } from '@atlassian/teams-common/context-config';

export const getTeamCentralGraphqlUrl = (cloudId: string) =>
	`${getConfig().stargateRoot}/townsquare/s/${cloudId}/graphql`;
export const getUnshardedTeamCentralGraphqlUrl = () =>
	`${getConfig().stargateRoot}/watermelon/graphql`;
export const AGG_URL = `${getConfig().stargateRoot}/graphql`;
